import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';

import { EpcotConfig, MarqueeConfig } from '@frontend/sports/common/client-config-data-access';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { SportsThemedIconButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { TwoDigitConverterPipe } from '../common/two-digit-converter.pipe';
import { ScoreDetails } from './odd-increment-decrement.models';

@Component({
    selector: 'ms-odd-increment-decrement',
    templateUrl: './odd-increment-decrement.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DsButtonIcon, IconCustomComponent, TwoDigitConverterPipe, SportsThemedIconButtonDirective],
})
export class OddIncrementDecrementComponent implements OnChanges {
    private marqueeConfig = inject(MarqueeConfig);
    private epcotConfig = inject(EpcotConfig);

    @Input() position: number;
    @Input() participantScore: number;
    @Input() participantLiveScore: number;
    @Input() shouldAddPrefix = false;
    @Input() themedButtonInverse: ThemeOptions<boolean> = {};
    @Output() changeScoreEvent = new EventEmitter<ScoreDetails>();
    isEpcotEnableed = false;

    constructor() {
        this.isEpcotEnableed = this.epcotConfig.isEnabled;
    }

    get isDecrementForbidden(): boolean | null {
        return !this.participantScore || this.participantLiveScore >= this.participantScore ? true : null;
    }

    get isIncrementForbidden(): boolean | null {
        return this.participantScore === this.marqueeConfig.maxCorrectScoreGoals ? true : null;
    }

    ngOnChanges(changes: SimpleChanges): void {
        const liveScore = changes.participantLiveScore;
        if (!liveScore || liveScore.isFirstChange()) {
            return;
        }
        if (
            liveScore.currentValue &&
            liveScore.previousValue &&
            liveScore.currentValue > liveScore.previousValue &&
            this.participantScore < liveScore.currentValue
        ) {
            this.increment();
        }
    }

    increment(event?: Event): void {
        if (!this.isIncrementForbidden) {
            this.preventAction(event);
            this.participantScore++;
            this.changeScoreEvent.emit({ position: this.position, score: this.participantScore });
        }
    }

    decrement(event: Event): void {
        this.preventAction(event);

        if (this.participantScore !== 0 && this.participantLiveScore < this.participantScore) {
            this.participantScore--;
            this.changeScoreEvent.emit({ position: this.position, score: this.participantScore });
        }
    }

    private preventAction(event?: Event): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
